import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import FormViewer from "../FormViewer";

class Preview extends Component {
  state = {
    show: false,
  };

  constructor(props) {
    super(props);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleClose() {
    this.setState({ show: false });
  }

  render() {
    return (
      <React.Fragment>
        <button className="btn btn-indigo rounded-0" onClick={this.handleShow}>
          Preview
        </button>

        <Modal size="xl" show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Form Preview</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <FormViewer
              Widgets={this.props.Widgets}
              PreviewMode={true}
              //Form_ID={0}
            />
          </Modal.Body>

          <Modal.Footer>
            <button className="btn btn-secondary" onClick={this.handleClose}>
              Close
            </button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  }
}

export default Preview;
